import { io } from 'socket.io-client';
import useAuthStore from '../stores/useAuthStore';
import useMessageStore from '../stores/useMessageStore';
import useNotificationStore from '../stores/useNotificationStore';

let socket = null;

export const initializeSocket = (token) => {
  if (socket) {
    socket.disconnect();
  }

  socket = io(process.env.REACT_APP_SOCKET_URL, {
    auth: { token },
    transports: ['websocket']
  });

  socket.on('connect', () => {
    const { user } = useAuthStore.getState();
    if (user) {
      socket.emit('joinUserRoom', user._id);
    }
  });

  // NEW: Safe listener setup — only initialize once
  if (!socket.__listenersInitialized) {
    socket.__listenersInitialized = true;

    // Handle new messages
    socket.on('newMessage', ({ conversationId, message }) => {
      const { currentConversation } = useMessageStore.getState();
      if (currentConversation === conversationId) {
        useMessageStore.getState().handleNewMessage(message);
      }
      useMessageStore.getState().fetchConversations(); // update list
    });

    // Handle notifications
    socket.on('newNotification', (notification) => {
      useNotificationStore.getState().addNotification(notification);
    });

    // Typing indicators
    socket.on('typingStart', ({ conversationId, userId, userName }) => {
      useMessageStore.getState().handleTypingStart(conversationId, userId, userName);
    });

    socket.on('typingStop', ({ conversationId, userId }) => {
      useMessageStore.getState().handleTypingStop(conversationId, userId);
    });

    // Read receipts
    socket.on('messagesRead', ({ conversationId, userId }) => {
      useMessageStore.getState().handleMessagesRead(conversationId, userId);
    });

    socket.on('messageEdited', ({ messageId, content, editedAt }) => {
      useMessageStore.getState().handleMessageEdited(messageId, content, editedAt);
    });

    socket.on('messageDeleted', ({ messageId }) => {
      useMessageStore.getState().handleMessageDeleted(messageId);
    });

    socket.on('reactionUpdated', ({ messageId, reactions }) => {
      useMessageStore.getState().handleReactionUpdated(messageId, reactions);
    });

    // Handle payment verification
    socket.on('payment_verified', (data) => {
      useNotificationStore.getState().addNotification({
        type: 'payment',
        message: `Payment successful! You are now enrolled in "${data.courseTitle}"`,
        metadata: {
          courseId: data.courseId,
          paymentId: data.enrollmentId
        }
      });
    });
  }

  return socket;
};

// ✅ Return null instead of throwing — safer
export const getSocket = () => {
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};